import * as getters from './getters';
import * as actions from './actions';
import mutations from './mutations';

let state = {
  account: {
    id: 0,
    first_name: '',
    last_name: '',
    email: '',
    created_at: '0001-01-01T00:00:00',
    role: 'User',
    role_id: 0,
    groups: [],
  },
  apikey: '',
  isLogged: false,
  language: 'en',
  jwt: '',
  resetInfo: null,
  registerInfo: null,
  acceptedCookies: false,
  secretQuestions: [],
};

if (/^fr\b/.test(window.navigator.language)) {
  state.language = 'fr';
}

const userInfo = localStorage.getItem('userInfo');
const acceptedCookies = localStorage.getItem('acceptedCookies');

if (userInfo) {
  state = JSON.parse(userInfo);
  if (state.apikey) state.isLogged = true;
}

if (acceptedCookies) {
  const today = new Date();
  let newCookies = new Date(acceptedCookies);
  newCookies = new Date(newCookies.setMonth(newCookies.getMonth() + 13));

  state.acceptedCookies = today.getTime() <= newCookies.getTime();
} else {
  state.acceptedCookies = false;
}

export default {
  state,
  getters,
  actions,
  mutations,
};
